var $2bd2c84dbaab5624$exports = {};
$2bd2c84dbaab5624$exports = {
    "collapse": `\u{5DB}\u{5D5}\u{5D5}\u{5E5}`,
    "expand": `\u{5D4}\u{5E8}\u{5D7}\u{5D1}`
};


export {$2bd2c84dbaab5624$exports as default};
//# sourceMappingURL=he-IL.module.js.map
